import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ContactoData {
  planActual: string;
}

@Component({
  selector: 'app-contacto-dialog',
  template: `
    <div class="contacto-dialog">
      <div class="dialog-header">
        <h2 mat-dialog-title>Contactar para actualizar a otro plan</h2>
        <button mat-icon-button (click)="closeDialog()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-dialog-content>
        <div class="contacto-content">
          <p class="info-text">Para mayor información sobre cómo actualizar su plan, contáctenos por WhatsApp:</p>

          <div class="contact-list">
            <div class="contact-item">
              <div class="contact-info">
                <div class="contact-name">Asunción:</div>
                <div class="contact-number">+595 981 473578</div>
              </div>
              <button mat-raised-button class="whatsapp-button" (click)="contactarWhatsApp('595981473578')">
                <span class="whatsapp-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path fill="currentColor" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                </span>
                <span class="whatsapp-text">WhatsApp</span>
              </button>
            </div>

            <div class="contact-item">
              <div class="contact-info">
                <div class="contact-name">Ciudad del Este:</div>
                <div class="contact-number">+595 981 191421</div>
              </div>
              <button mat-raised-button class="whatsapp-button" (click)="contactarWhatsApp('595981191421')">
                <span class="whatsapp-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path fill="currentColor" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                </span>
                <span class="whatsapp-text">WhatsApp</span>
              </button>
            </div>

            <div class="contact-item">
              <div class="contact-info">
                <div class="contact-name">Encarnación:</div>
                <div class="contact-number">+595 985 492120</div>
              </div>
              <button mat-raised-button class="whatsapp-button" (click)="contactarWhatsApp('595985492120')">
                <span class="whatsapp-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path fill="currentColor" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                </span>
                <span class="whatsapp-text">WhatsApp</span>
              </button>
            </div>
          </div>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-button (click)="closeDialog()">Cerrar</button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .contacto-dialog {
      display: flex;
      flex-direction: column;
      max-height: 90vh;
      overflow: hidden;
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 24px;
      background-color: #f5f5f5;
      border-bottom: 1px solid #e0e0e0;
    }

    .dialog-header h2 {
      margin: 0;
      font-size: 22px;
      font-weight: 500;
      color: #333;
    }

    mat-dialog-content {
      padding: 30px;
      overflow-y: auto;
    }

    .contacto-content {
      display: flex;
      flex-direction: column;
      gap: 30px;
    }

    .info-text {
      font-size: 18px;
      margin: 0;
      color: #333;
      line-height: 1.5;
    }

    .contact-list {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    .contact-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      border-radius: 12px;
      background-color: #f9f9f9;
      border: 1px solid #e0e0e0;
      transition: all 0.3s ease;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    }

    .contact-item:hover {
      background-color: #f0f0f0;
      transform: translateY(-3px);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
      border-color: #ccc;
    }

    .contact-info {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .contact-name {
      font-weight: 600;
      font-size: 18px;
      color: #333;
    }

    .contact-number {
      font-size: 16px;
      color: #666;
    }

    .whatsapp-button {
      background-color: #25D366;
      color: white;
      border-radius: 8px;
      padding: 8px 16px;
      font-size: 16px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 8px;
      box-shadow: 0 3px 6px rgba(37, 211, 102, 0.2);
      transition: all 0.3s ease;
      min-width: 140px;
      justify-content: center;
    }

    .whatsapp-button:hover {
      background-color: #22c15e;
      box-shadow: 0 5px 12px rgba(37, 211, 102, 0.3);
      transform: translateY(-2px);
    }

    .whatsapp-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .whatsapp-text {
      font-weight: 500;
    }

    mat-dialog-actions {
      padding: 20px 24px;
      margin: 0;
      border-top: 1px solid #e0e0e0;
    }
  `]
})
export class ContactoDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ContactoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContactoData
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }

  contactarWhatsApp(telefono: string): void {
    const mensaje = `Hola, estoy interesado en actualizar mi plan ${this.data.planActual} a otro plan. ¿Pueden brindarme más información?`;
    const url = `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
  }
}
